<template>
  <div
    id="china"
    class="pt"
    :class="{ h5: this.$store.state.webType === 'h5' }"
  >
    <el-row :span="24" class="page-content">
      <div class="publish_events_box">
        <div class="publish_events_box_title">Publish List</div>
        <div class="publish-list">
          <div class="list-item"  v-for="(item, index) in this.list" :key="index">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-info">
              <div class="info-status">Status：<span>{{ statusName(item.audit) }}</span></div>
              <div class="info-btn">
                <div class="btn-item"  
                @click="$goDetail(item.aId, getType(item.type))">Preview</div>
                <div class="btn-item"
                @click="goEdit(item.aId,item.type)"
                >Edit</div>
                <div class="btn-item"
                @click="goDel(item.aId,item.audit)"
                >Delete</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <el-row>
       <div class="more-btn" v-if=" !this.page.isLastPage " @click="nextPage">
          More <i class="el-icon"></i>
        </div>
    </el-row>
  </div>
</template>

<script>
import Tinymce from "@/components/tinymce";

export default {
  name: "china",
  components: {
    Tinymce,
  },
  data() {
    return {
      uploadList: [],
      gutterWidth: 20,
      page:{
        total: null,
        isLastPage: null,
        pageNum: null
      },
      ruleForm: {
        title: "",
        label: "",
        country: "",
        coverImage: "",
        brief: "",
        content: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      list: []
    };
  },
  mounted() {
    if (this.$route.query.token) {
      sessionStorage.setItem("token", this.$route.query.token);
    }
    this.getList();
  },
  beforeUpdate() {
    // this.resetForm("ruleForm");
    // this.ruleForm = {};
    // this.uploadList = [];
  },
  methods: {
    getType(type){
      let val = type === 1 ? 'news' : 'events';
      return val;
    },
    statusName(val){
      if(val === 0){
        return "Published"
      }
       return "Pending Review"
    },
    goDel(aId,state){
       if(state === 0){
          this.$confirm('This content has been published, are you sure to delete it?', 'Tip', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancle',
          type: 'warning'
        }).then(() => {
          this.$post(this.$api + "/un/webrelease/remove", {aId:aId}).then(
            (res) => {
              this.$message({
                message:
                  this.$store.state.lang == "FR"
                    ? "Soumettre avec succès!"
                    : "Submit Success！",
                type: "success",
              });
              this.getList();
            }
          );
        })
       }
       else{
        this.$post(this.$api + "/un/webrelease/remove", {aId:aId}).then(
            (res) => {
              this.$message({
                message:
                  this.$store.state.lang == "FR"
                    ? "Soumettre avec succès!"
                    : "Submit Success！",
                type: "success",
              });
              this.getList();
            }
          );
       }
       
       
    },
    goEdit(aId,type){
      this.$emit('update-parent-data', aId,type);
    },
    nextPage(){
      this.listQuery.pageNum = this.listQuery.pageNum+1;
      this.getList('append');
    },
    getList(type) {
      this.listQuery.token = sessionStorage.getItem("tokenPub");
      this.$get(this.$api + "/un/webrelease/articlelist", this.listQuery).then((res) => {
          if(type == 'append'){
            this.list = this.list.concat(res.data.list);
          }
          else{
            this.list = res.data.list;
          }
          console.log("bbb",this.list)
          this.page.total = res.data.total;
          this.page.isLastPage = res.data.isLastPage;
          this.listQuery.pageNum = res.data.pageNum;
        }
      ).catch((err) => {
        //跳转至登录页面
        this.$router.push("/login");
      });
    },
    handleBeforeUpload(file) {
      console.log(file);
      this.fileType = file.name.split(".")[1];
    },
    uploadURL(file) {
      console.log(file, "file");
      const formData = new FormData();
      formData.append("file", file.file);
      console.log(formData, "formData");
      //注意哦，这里指定文件夹'image/'，尝试过写在配置文件，但是各种不行，写在这里就可以
      var fileName =
        "video/" + "ymy_" + `${Date.parse(new Date())}` + "." + this.fileType;
      let pageName = file.file.name;
      console.log(pageName);
      // this.videoFlag = true;
      let that = this;
      this.$post(this.$api + "/web/common/upload", formData).then((res) => {
        this.ruleForm.coverImage = res.url;
      });
      return;
      //定义唯一的文件名，打印出来的uid其实就是时间戳
      client()
        .multipartUpload(fileName, file.file, {
          headers,
          progress: function (percentage, cpt) {
            console.log("打印进度", percentage);
            console.log(that.videoFlag);
            that.videoUploadPercent = parseInt(percentage * 100);
          },
        })
        .then((res) => {
          console.log(res);
          //此处赋值，是相当于上传成功之后，手动拼接服务器地址和文件名
          this.form.imgUrl = res.res.requestUrls[0].split("?")[0];
          this.uploadList = [{ name: pageName, url: this.form.imgUrl }];
          console.log(this.uploadList);
          this.$message.success("作品上传成功！");
          // 进度条恢复到初始状态
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        });
    },
    handleRemove: function (file, fileList) {
      this.uploadList = [];
    },
    submitForm(formName) {
      this.ruleForm.language = localStorage.getItem("lang");
      this.ruleForm.token = sessionStorage.getItem("tokenPub");
      this.$refs[formName].validate((valid) => {
        console.log(this.ruleForm, "ruleForm");
        if (valid) {
          this.$post(this.$api + "/un/webnews/addnews", this.ruleForm).then(
            (res) => {
              this.$message({
                message:
                  this.$store.state.lang == "FR"
                    ? "Soumettre avec succès!"
                    : "Submit Success！",
                type: "success",
              });
              // this.resetForm("ruleForm");
              this.ruleForm = {};
              this.uploadList = [];
              this.$emit("handleSubmitList", "");
              // this.$router.push("/publishlist");
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_btn_form {
  background-color: rgba(0, 93, 176, 1);
  border-radius: 35px;
  height: 49px;
  width: 307px;
}

.publish_events_box {
  margin: 0 auto;
  width: 100%;
  color: #333333;
  border-top: 1px solid #e4e4e4;
  .publish_events_box_title {
    font-size: fh(36vh, pc);
    line-height: fh(44vh, pc);
    font-weight: 500;

    white-space: nowrap;
    padding: fh(20vh, pc) 0;
  }
  .publish-list {
    width: 100%;
    padding-top: fh(20vh, pc);
    .list-item {
      padding: fh(40vh, pc) fw(40vw, pc);
      background-color: #f7f7f7;
      margin-bottom: fh(40vh, pc);
      .item-title {
        font-size: fh(32vh, pc);
        line-height: fh(46vh, pc);
        padding-bottom: fh(20vh, pc);
      }
      .item-info {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .info-status {
          font-size: fh(18vh, pc);
          line-height: fh(26vh, pc);
          color: #999999;
          span {
            color: #333;
          }
        }
        .info-btn {
          display: flex;
          .btn-item {
            padding: fh(8vh, pc) fw(26vw, pc);
            background-color: #fff;
            color: #0077d4;
            border: 1px solid #ececec;
            font-size: fh(18vh, pc);
            line-height: fh(22vh, pc);
            border-radius: fh(18vh, pc);
            margin-left: fw(20vw, pc);
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
